import $ from "jquery";

$(document).on('ajaxError', function handleAjaxError(_, xhr, settings) {
  if (xhr.status === 500 && settings.crossDomain === false) {
    window.location = '/500.html';
  }
});
